import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';

import { PageNotFoundService } from '../lib/components/generics/page-not-found/page-not-found.service';

import { GlobalErrorService } from './global-error.service';

export const globalHttpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorService = inject(GlobalErrorService);
   const pageNotFoundService = inject(PageNotFoundService);
  return next(req).pipe(
    tap({
      error: (error: HttpErrorResponse) => {
        if ([500, 503].includes(error.status)) {
          errorService.handleGlobalErrorStatus(error.status);
        } 
        if(error.status === 404){
            pageNotFoundService.isPageNotFound.set(true);
        }
      }
    })
  );
};
